export default "__VITE_ASSET__BMEzerg8__"